const en = {
  layout: {
    cos_button: {
      phone: 'Phone',
      update_phone_number_message: 'Phone number was successfully updated!'
    },
    time: {
      days: 'Days',
      hours: 'Hours',
      mins: 'Mins',
      secs: 'Secs',
      starts: 'Starts',
      starts_immediately: 'Starts Immediately'
    },
    field: {
      host: 'Host'
    },
    copy: 'Copy'
  },
  validations: {
    email: 'must be a valid email',
    phone: 'must be a valid phone',
    required_field: 'is a required field'
  },
  mailer: {
    need_help: 'Need Help?',
    stop_reminders: 'Stop receiving reminders',
    cancel_registration: 'Cancel registration',
    report_abuse: 'Report Abuse'
  },
  datetime: {
    no_sessions: 'No Sessions Available',
    empty_label: 'Date/Time'
  },
  errors: {
    verification_failed: 'Verification failed. Please try again.',
    session_unavailable: 'The time you selected is no longer available. Please choose another session slot.',
    challenge_email_mismatch: 'Please register with the same email you used to register for the event'
  }
}

export default en
